var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStairs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stairs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 166",
    d: "M17.4 17.5H2.6C2.54477 17.5 2.5 17.4552 2.5 17.4V14.4421C2.5 14.3869 2.54477 14.3421 2.6 14.3421H5.55789C5.61312 14.3421 5.65789 14.2973 5.65789 14.2421V10.4947C5.65789 10.4395 5.70267 10.3947 5.75789 10.3947H9.50526C9.56049 10.3947 9.60526 10.35 9.60526 10.2947V6.54737C9.60526 6.49214 9.65003 6.44737 9.70526 6.44737H13.4526C13.5079 6.44737 13.5526 6.4026 13.5526 6.34737V2.6C13.5526 2.54477 13.5974 2.5 13.6526 2.5H17.4C17.4552 2.5 17.5 2.54477 17.5 2.6V17.4C17.5 17.4552 17.4552 17.5 17.4 17.5Z",
    stroke: "white",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairs);
export default __webpack_public_path__ + "static/media/stairs.935a33dfc7426c97ab80e3a9bcd9a54e.svg";
export { ForwardRef as ReactComponent };